import request from '@/utils/requset'
 
// 图片验证码
export function captcha() {
  return request({
    url: `h5/auth/captcha`,
    method: 'get'
  })
} 

// 登录
export function login(data) {
  return request({
    url: `h5/auth/login`,
    method: 'post',
    data: data
  })
}

// 用户信息
export function userInfo() {
  return request({
    url: `h5/user/info`,
    method: 'get'
  })
} 

// 注册 发送验证码
export function sendCode(data) {
  return request({
    url: `h5/auth/sendCode`,
    method: 'post',
    data: data
  })
}

// 注册
export function register(data) {
  return request({
    url: `h5/auth/register`,
    method: 'post',
    data: data
  })
}